
import { ColumnRank, ColumnStartOrder, ColumnBib, ColumnName, ColumnWarnings, ColumnNoc, ColumnResult, ColumnRecords, ColumnExpander, ColumnQualification } from "components/common/TableColumns"

export function TableColumns(columnsAdded) {
    let columnsExt = columnsAdded.filter(row => row.ei_code === 'INTERMEDIATE').map((val, index) => {
        return (
            {
                Header: val.ei_value,
                //accessor: 'extendedResults[' + val.ei_pos + '].er_value', // accessor is the "key" in the data
                accessor: (props) => (
                    props?.extendedResults.filter(row => row.er_code === 'INTERMEDIATE' && row.er_pos === val.ei_pos).length > 0
                        ? Number(props.extendedResults.filter(row => row.er_code === 'INTERMEDIATE' && row.er_pos === val.ei_pos).map((val) => { return val.er_sortorder }))
                        : null
                ),

                isVisible: false,
                columnIndex: val.ei_pos,
                id: 'ResultEx_' + val.ei_pos,
                Cell: (props) => (
                    props.cell.row.original.extendedResults
                        ? props.cell.row.original.extendedResults.filter(row => row.er_code === 'INTERMEDIATE' && row.er_pos === val.ei_pos).map((val) => { return (val.er_value) })
                        : ''
                ),
            }
        )
    })


    return (
        [
            ColumnRank({}),
            ColumnStartOrder({ label: 'HeaderOrder' }),
            ColumnBib({}),
            ColumnNoc({}),
            ColumnName({}),
            ColumnWarnings({}),
            ...columnsExt,
            ColumnResult({}),
            ColumnQualification({}),
            ColumnRecords({}),
            ColumnExpander({ type: 'extendedResults', expandIrm: true })
        ]
    )
}


export default TableColumns
